import React from 'react';
import { useConnect } from 'redux-bundler-hook';
import { isImpersonating } from 'utils/impersonationSession';

import {
  StyledDefaultTemplateLeftColumnUserDetails,
  StyledImpersonating,
  StyledSignedInAs,
  StyledUserAvatar,
  StyledUserDetailsWrapper,
  StyledUserFullName,
} from './styles';

const DefaultTemplateLeftColumnUserDetails = () => {
  const {
    fullUser: { fullName, id },
  } = useConnect('selectFullUser');

  return (
    <>
      {isImpersonating() ? (
        <StyledImpersonating>Impersonating</StyledImpersonating>
      ) : null}
      <StyledDefaultTemplateLeftColumnUserDetails>
        <StyledUserAvatar id={id} showLoader={!fullName} />
        {id ? (
          <StyledUserDetailsWrapper>
            <StyledSignedInAs>Signed in as</StyledSignedInAs>
            <StyledUserFullName>{fullName}</StyledUserFullName>
          </StyledUserDetailsWrapper>
        ) : null}
      </StyledDefaultTemplateLeftColumnUserDetails>
    </>
  );
};

export default DefaultTemplateLeftColumnUserDetails;
